import { api } from './api';
import type {
  AffiliatePartnersParams,
  AffiliatePartnersResponse,
  AffiliatePartnerDetail,
  AffiliatePartnerItem,
  CreateAffiliatePartnerRequest,
  UpdateAffiliatePartnerRequest,
  UsernameAvailability,
} from '../types/affiliatePartners';

const BASE_PATH = '/admin/affiliate-partners';

export const getPartners = async (
  params: AffiliatePartnersParams
): Promise<AffiliatePartnersResponse> => {
  const response = await api.get(BASE_PATH, { params });
  return response.data;
};

export const getPartnerDetail = async (id: number): Promise<AffiliatePartnerDetail> => {
  const response = await api.get(`${BASE_PATH}/${id}`);
  return response.data;
};

export const createPartner = async (
  body: CreateAffiliatePartnerRequest
): Promise<AffiliatePartnerItem> => {
  const response = await api.post(BASE_PATH, body);
  return response.data;
};

export const updatePartner = async (
  id: number,
  body: UpdateAffiliatePartnerRequest
): Promise<AffiliatePartnerItem> => {
  const response = await api.patch(`${BASE_PATH}/${id}`, body);
  return response.data;
};

/**
 * Live handle check for the create form. Runs the same shape / reserved /
 * retired / taken rules the create call enforces, so the admin finds out
 * before submitting rather than after.
 */
export const checkUsername = async (username: string): Promise<UsernameAvailability> => {
  const response = await api.get(`${BASE_PATH}/username-available`, {
    params: { username },
  });
  return response.data;
};

export const affiliatePartnersService = {
  getPartners,
  getPartnerDetail,
  createPartner,
  updatePartner,
  checkUsername,
};
